/**
 * Navigation and routing utilities for FreeFlash.
 * URLs are strictly clean: user_id is never passed in query params or URLs.
 * Content-specific parameters (such as ?unit= or ?song_id= or #hashes) are preserved.
 */

import { getUser } from './auth';

const STORAGE_KEY_LANG_ID = "freeflash_last_lang_id";

export function getStoredUserId() {
    const user = getUser();
    return user ? String(user.id) : null;
}

export function setStoredUserId(userId) {
    // Deprecated: user identity is managed by server session and AuthContext
}

export function getStoredLangId() {
    try {
        return localStorage.getItem(STORAGE_KEY_LANG_ID) || '0';
    } catch {
        return '0';
    }
}

export function setStoredLangId(langId) {
    if (langId === null || langId === undefined) return;
    try {
        localStorage.setItem(STORAGE_KEY_LANG_ID, String(langId));
    } catch { }
}

/**
 * Returns current authenticated user ID from session/user cache.
 * URL parameters are completely ignored for security.
 */
export function getEffectiveUserId(explicitUserId) {
    if (explicitUserId !== null && explicitUserId !== undefined && explicitUserId !== "") {
        return String(explicitUserId);
    }
    const user = getUser();
    return user ? String(user.id) : "0";
}

/**
 * Returns active language ID from storage or explicit override.
 */
export function getEffectiveLangId(explicitLangId) {
    if (explicitLangId !== null && explicitLangId !== undefined && explicitLangId !== "") {
        setStoredLangId(explicitLangId);
        return String(explicitLangId);
    }
    return getStoredLangId() || "0";
}

/**
 * Builds clean dashboard URL without exposing user_id or lang_id.
 * Example: /dashboard#vocabulary or /dashboard#music
 */
export function buildDashboardUrl(sectionHash = "", overrides = {}) {
    const cleanHash = sectionHash ? (sectionHash.startsWith("#") ? sectionHash : `#${sectionHash}`) : "";
    return `/dashboard${cleanHash}`;
}

export function navigateToDashboard(sectionHash = "", overrides = {}) {
    const url = buildDashboardUrl(sectionHash, overrides);
    window.location.href = url;
}
